import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';

import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';

import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { FlashSubscriptionDetailsRequest } from '../api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsrequest';
import { FlashSubscriptionDetailsResponse, FlashSubscriptionDetailsResponseDtoImpl } from '../api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsresponse';
import { FlashMessageSubscriptionBuilder } from '../dto/flashsubscriptiondetails/flashmessagesubscriptionbuilder';
import { FlashMessageSubscriptionDetailsDtoImpl } from '../dto/flashsubscriptiondetails/flashmessagedetails';

export class FlashSubscriptionDetailsAPIProcessorImpl extends APIProcessorImpl<FlashSubscriptionDetailsRequest, FlashSubscriptionDetailsResponse>
{
    // execute(): void 
    // {
    //     let flashmessagedto = new FlashMessageSubscriptionDetailsDtoImpl();
    //     let response = new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, "Get FlashSubscriptionDetails Success");
    //     flashmessagedto.setIsNewUser(false);
    //     flashmessagedto.setStatus("A");
    //     response.setFlashSubscriptionDetailsResponseDto(flashmessagedto);
    //     this.getAPISuccess(response);
    // }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, "Get FlashSubscriptionDetails Success");
                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                    response.setFlashSubscriptionDetailsResponseDto(new FlashMessageSubscriptionBuilder(responseMapper.getResponseMap()).buildAll());
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === 1013)//1013
                {
                    let flashmessagedto = new FlashMessageSubscriptionDetailsDtoImpl();
                    flashmessagedto.setStatus("D");
                    flashmessagedto.setIsNewUser(true);
                    response.setFlashSubscriptionDetailsResponseDto(flashmessagedto);
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
                else
                {
                    this.getAPIFailure(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, responseMapper.getStatusMsg()));
                }
                
                
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new FlashSubscriptionDetailsResponseDtoImpl(APIFeatures.GET_FLASH_SUBSCRIPTION, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getflashsubscriptiondetailsapiprocessor.tsx